/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListAssistantProposalsQueryResponse, ListAssistantProposalsPathParams, ListAssistantProposalsQueryParams, ListAssistantProposals400, ListAssistantProposals401, ListAssistantProposals403, ListAssistantProposals404, ListAssistantProposals409, ListAssistantProposals500 } from "../../types/assistantProposalsController/ListAssistantProposals.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listAssistantProposals } from "../../client/assistantProposalsController/listAssistantProposals.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listAssistantProposalsQueryKey = (organizationId: ListAssistantProposalsPathParams["organizationId"] | undefined, params?: ListAssistantProposalsQueryParams) => [{ url: '/api/organizations/:organizationId/assistant-proposals/', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListAssistantProposalsQueryKey = ReturnType<typeof listAssistantProposalsQueryKey>

export function listAssistantProposalsQueryOptions(organizationId: ListAssistantProposalsPathParams["organizationId"] | undefined, params?: ListAssistantProposalsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listAssistantProposalsQueryKey(organizationId, params)
        return queryOptions<ListAssistantProposalsQueryResponse, ResponseErrorConfig<ListAssistantProposals400 | ListAssistantProposals401 | ListAssistantProposals403 | ListAssistantProposals404 | ListAssistantProposals409 | ListAssistantProposals500>, ListAssistantProposalsQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listAssistantProposals(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List assistant proposals (farm-scoped, paginated)
 * {@link /api/organizations/:organizationId/assistant-proposals/}
 */
export function useListAssistantProposals<TData = ListAssistantProposalsQueryResponse, TQueryData = ListAssistantProposalsQueryResponse, TQueryKey extends QueryKey = ListAssistantProposalsQueryKey>(organizationId: ListAssistantProposalsPathParams["organizationId"] | undefined, params?: ListAssistantProposalsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListAssistantProposalsQueryResponse, ResponseErrorConfig<ListAssistantProposals400 | ListAssistantProposals401 | ListAssistantProposals403 | ListAssistantProposals404 | ListAssistantProposals409 | ListAssistantProposals500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listAssistantProposalsQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listAssistantProposalsQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListAssistantProposals400 | ListAssistantProposals401 | ListAssistantProposals403 | ListAssistantProposals404 | ListAssistantProposals409 | ListAssistantProposals500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}